// extracted by mini-css-extract-plugin
export default {"desktopContainer":"styles_desktopContainer__AtwTE","Header":"styles_Header__1yaEU","Logo":"styles_Logo__GuIVG","content":"styles_content__hH+iL"};